import { render, staticRenderFns } from "./SearchProductName.vue?vue&type=template&id=453c8b99&scoped=true&"
import script from "./SearchProductName.vue?vue&type=script&lang=js&"
export * from "./SearchProductName.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductName.vue?vue&type=style&index=0&id=453c8b99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c8b99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
